import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withDefaultParams from "Services/withDefaultParams";
import { isMainSiteCode } from "Utils/siteConfig";
import ReviewsSendHOC from "HOC/ReviewsSendHOC";
import TagButtonComponent from "Containers/TagButtonComponent";
import OfferedTariffsMobileContainer from "Containers/OfferedTariffsMobileContainer";
import { FILTER_TYPES } from "Containers/TariffsFilterContainer";
import { AddReviewContainerV2, ReviewListContainerV3 } from "Containers/Review";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import MobileTariffList from "ComponentsUI/MobileTariffList";
import { ShowMoreButton } from "ComponentsUI/Buttons";
import TariffsFilterContainer from "./Containers/TariffsFilterContainer";
import { Redirect404 } from "ComponentsUI/Redirects";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import { BlockReviews } from "ComponentsUI/Blocks";
import { ResetFiltersBlock } from "designSystem/EmptyContentBlocks/ResetFiltersBlock";
import { ShouldAddConvergentProvider } from "providers/shouldAddConvergentProvider";
import { OPERATOR_TAB_TARIFFS } from "stores/OperatorModel";
import { useGetMobileTagsQuery } from "routes/operator/routes/hooks";
import { useFiltersTariffs } from "../hooks";

const useStyles = createUseStyles((theme) => ({
	[`@media (min-width: ${theme.media.md})`]: {
		container: {
			marginTop: "50px",
		},
	},
}));

const MINUTES_RANGE_STEP = 10;

const RatesMobile = (props) => {
	let {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			text,
			mobileFiltersTouchModel,
		},
		match: { params },
		location: { search },
		history,
		operatorForCard: {
			info: { cnt_tariffs = 0 },
		},
	} = props;
	const siteCode = props.ApplicationModel.siteCode;

	const {
		tariffs,
		fetchMoreTariffs,
		totalTariffs,
		currentOperator,
		isTariffsLoading,
		resetFilters,
		setFilters,
		isLoading,
		initalFilters,
		currentFilters,
	} = useFiltersTariffs(search);

	const { isLoading: isMobileTagsLoading, mobileTags } = useGetMobileTagsQuery(!cnt_tariffs);

	const [filtersItems, setFiltersItems] = useState(null);

	useEffect(() => {
		const {
			ApplicationModel: { operatorModel },
		} = props;
		if (operatorModel.visibleTab !== OPERATOR_TAB_TARIFFS) {
			operatorModel.changeTab(OPERATOR_TAB_TARIFFS);
		}
	}, []);

	useEffect(() => {
		if (!initalFilters) {
			return;
		}

		setFiltersItems([
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.minutes,
					title: text.MINUTES,
					value: currentFilters.minutes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							minutes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							minutes: null,
						});
					},
					step: MINUTES_RANGE_STEP,
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_minutes_min",
					inputNameMax: "change_minutes_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.gigabytes,
					title: text.INTERNET,
					value: currentFilters.gigabytes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							gigabytes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							gigabytes: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_gb_min",
					inputNameMax: "change_gb_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.price,
					title: text.SUBSCRIPTION_FEE,
					value: currentFilters.price,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							price: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							price: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_price_min",
					inputNameMax: "change_price_max",
				},
			},
		]);
	}, [
		currentFilters.gigabytes,
		currentFilters.minutes,
		currentFilters.price,
		initalFilters,
		setFilters,
		text,
		currentOperator,
		mobileFiltersTouchModel,
	]);

	const classes = useStyles();
	const loading = isMobileTagsLoading || isTariffsLoading || isLoading;

	// Проверка, если нет тарифов на 2 тегах, то 404.
	if (
		(params.tagCode === "korporativnyj" || params.tagCode === "bez-interneta") &&
		!tariffs.length
	) {
		return (
			<Redirect404
				message404={"Выбран тег korporativnyj/bez-interneta у оператора на котором нет тарифов"}
			/>
		);
	}

	// Есть ли выбранные фильтры
	const selected = filtersItems ? filtersItems.filter((item) => item.props.value) : [];

	// Если тарифов нет, выводим предложенные // && !selected.length
	if (!loading && !tariffs.length && !selected.length) {
		return <OfferedTariffsMobileContainer mobileTags={mobileTags} operatorRatesMobile={true} />;
	}

	return (
		<PaddingTop containerClass={classes.container}>
			<PaddingBottom>
				{filtersItems && (
					<TariffsFilterContainer filters={filtersItems} onMobileResetButtonClick={resetFilters} />
				)}
				<Container>
					{isMainSiteCode(siteCode) && <div></div>}
					<TagButtonComponent
						mobileTags={mobileTags}
						tagCode={params.tagCode}
						operatorRates={true}
						operatorStyle={true}
					/>
					{loading ? (
						<StubOperatorTariffs />
					) : tariffs.length ? (
						<Row>
							<ShouldAddConvergentProvider value={true}>
								<MobileTariffList
									// TODO: rework key using to component decomposition or additional route
									key={params.tagCode}
									tariffs={tariffs}
									text={text}
								/>
							</ShouldAddConvergentProvider>
						</Row>
					) : (
						<ResetFiltersBlock text={text} onResetClick={resetFilters} />
					)}
					{tariffs.length < totalTariffs && (
						<ShowMoreButton
							disabled={isTariffsLoading}
							windowSizes={windowSizes}
							text={text}
							onClickHandler={fetchMoreTariffs}
						/>
					)}
					{!params.tagCode && (
						<PaddingTop>
							<BlockReviews
								reviewLocation="operator_ratesmobile"
								queryType="regionFull"
								text={text}
								reviews={
									<ReviewListContainerV3
										text={text}
										reviewLocation="about_operator"
										queryType="reviews"
									/>
								}
								control={
									<ReviewsSendHOC>
										<AddReviewContainerV2
											reviewLocation="about_operator"
											queryType="operator"
											selectProvidersPlaceholder={text.filtersOperator}
											textHeader={text.WRITE_REVIEW}
										/>
									</ReviewsSendHOC>
								}
							/>
						</PaddingTop>
					)}
				</Container>
			</PaddingBottom>
		</PaddingTop>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(RatesMobile)));
